import * as React from "react";
import {RouteComponentProps} from "react-router-dom";
import {getApplicationRoute} from "loan-application/application/routes";
import "./styles.scss";

interface IConnectProps {
    dispatch?: (action: any) => void;
}
function ApplicationIndex(props: IConnectProps & RouteComponentProps) {
    return getApplicationRoute(props.match.path);
}

export default  ApplicationIndex;
